import axios from 'axios';
import { handleRequest } from 'helpers/api';

const CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL;

const chatbotApi = axios.create({
  baseURL: CHATBOT_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-chatbot-api-key': process.env.REACT_APP_CHATBOT_SECRET_KEY
  }
});

export interface ChatbotResponse {
  response: string;
}

export const getChatbotResponse = async (question: string) => {
  return handleRequest<ChatbotResponse>(chatbotApi.post('/', { question }));
};
